/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/55967492
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import any from 'ramda/src/any';
import clone from 'ramda/src/clone';
import concat from 'ramda/src/concat';
import equals from 'ramda/src/equals';
import filter from 'ramda/src/filter';
import isEmpty from 'ramda/src/isEmpty';
import isNil from 'ramda/src/isNil';
import length from 'ramda/src/length';
import values from 'ramda/src/values';
import { toast } from 'react-toastify';
import Accordion from '@components/@core/Accordion';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import CareerCertificationHeader from '@components/CareerCertificationHeader';
import Dropdown from '@components/@core/Dropdown';
import Filter from '@components/@core/Filter';
import Input from '@components/@core/Input';
import ResponsiveTabs from '@components/@core/ResponsiveTabs';
import * as ProgramsList from '@components/LibraryProgramsList';
import TrainingCourses from '~/views/Manage/Reports/TrainingCourses';
import Pagination from '@components/@core/Pagination';
import StepBar from '@components/@core/StepBar';
import Settings from '@components/@core/Settings';
import Toggle from '@components/@core/Toggle';
import { LibraryLevels, LibraryTypes } from '~/services/config';

const OPTIONS = [{ id: 1, value: 'Default from courses, Target for track' }];

class Add extends Component {
    state = {
        title: '',
        description: '',
        level: 1,
        expiration: 0,
        author_id: null,
        department_id: [],
        competency_id: [],
        category_id: [],
        role: {},
        iconLink: LibraryTypes['careers'].icon,
        programLevels: [
            {
                levelTitle: 'Level 1',
                chronology_lock: false,
                time_lock: false,
                habits: [],
                quotas: [],
                courses: [],
                tracks: [],
                pdf: [],
                word: [],
                powerpoint: [],
            },
        ],
        jobs: this.props.jobs,
        quotaOptions: this.props.quotaOptions,
        authors: this.props.tags.authors,
        departments: this.props.tags.departments,
        competencies: this.props.tags.competencies,
        categories: this.props.tags.categories,
        company: this.props.company,
        quotaData: false,
        habitData: false,
        levelInd: 0,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { modalData } = nextProps;
        const { programLevels, levelInd } = prevState;
        const modules = clone(programLevels);
        if (modalData.after) {
            const { quotas, habits } = modalData.after;
            if (quotas) {
                if (!equals(quotas, modules[levelInd]['quotas'])) {
                    modules[levelInd]['quotas'] = concat(modules[levelInd]['quotas'], quotas);
                    return { programLevels: modules, quotaData: true };
                }
            }
            if (habits) {
                if (!equals(habits, modules[levelInd]['habits']) && Math.abs(habits.length - modules[levelInd]['habits'].length) >= 1) {
                    modules[levelInd]['habits'] = habits;
                    return { programLevels: modules, habitData: true };
                }
            }
        }
        return null;
    }

    componentDidUpdate(prevState) {
        const { quotaData, habitData, levelInd } = this.state;
        if (quotaData && !prevState.quotaData) {
            this.handleAddModule('quotas', levelInd);
            this.setState({ quotaData: false });
        }
        if (habitData && !prevState.habitData) {
            this.handleAddModule('habits', levelInd);
            this.setState({ habitData: false });
        }
    }

    handleFilter = (type, e) => {
        let company = this.state.company;

        if (isNil(e)) return;
        if (type === 'company') {
            company = e[0];
        } else if (type === 'employee') {
        }

        if (company.id < 0) return;

        this.setState({ company });
    };

    handleSelectTags = (key) => (tag) => {
        switch (key) {
            case 'author':
                this.setState({ author_id: tag[0] });
                break;
            case 'department':
                this.setState({ department_id: tag });
                break;
            case 'competency':
                this.setState({ competency_id: tag });
                break;
            case 'category':
                this.setState({ category_id: tag });
                break;
            case 'role':
                this.setState({ role: tag[0] });
            default:
                break;
        }
    };

    handleSelectLevels = (e) => {
        const level = e[0];
        let programLevels = [];
        for (let i = 0; i < level; i++) {
            programLevels[i] = {
                levelTitle: '',
                chronology_lock: false,
                time_lock: false,
                habits: [],
                quotas: [],
                courses: [],
                tracks: [],
                pdf: [],
                word: [],
                powerpoint: [],
            };
        }
        this.setState({ level, programLevels });
    };

    handleChangeLevel = (key, ind) => (e) => {
        const programLevels = clone(this.state.programLevels);
        programLevels[ind][key] = e;
        this.setState({ programLevels });
    };

    handleDrop = (e) => {
        this.setState({ iconLink: e });
    };

    handleSelectModule = (ind) => (e) => {
        const { programLevels } = this.state;
        const type = e[0].name;
        this.props.onModal({
            type: 'Attach Library',
            data: {
                before: {
                    show: [type],
                    modules: [],
                },
                after: programLevels[ind][type],
            },
            callBack: {
                onAttach: (e) => {
                    const modules = clone(programLevels);
                    modules[ind][type] = concat(modules[ind][type], e.templates);
                    this.setState({ programLevels: modules });
                },
                onAdd: () => this.handleNewModule(type, ind),
            },
        });
    };

    handleNewModule = (type, ind) => {
        const { programLevels } = this.state;
        let payload = {};
        if (type === 'quotas') {
            const modules = clone(programLevels);
            const quotas = modules[ind][type];
            payload = { type: 'Add New Quota', data: { after: { quotas } } };
        }
        if (type === 'habits') {
            const modules = clone(programLevels);
            const habits = modules[ind][type];
            payload = { type: 'Add New Habit', data: { after: { habits } } };
        }
        this.setState({ levelInd: ind });
        this.props.onModal(payload);
    };

    handleAddModule = (type, ind) => () => {
        const { programLevels } = this.state;
        this.props.onModal({
            type: 'Attach Library',
            data: {
                before: {
                    show: [type],
                    modules: [],
                },
                after: programLevels[ind][type],
            },
            callBack: {
                onAttach: (e) => {
                    const modules = clone(programLevels);
                    modules[ind][type] = concat(modules[ind][type], e.templates);
                    this.setState({ programLevels: modules });
                },
                onAdd: () => {
                    this.handleNewModule(type, ind);
                },
            },
        });
    };

    handleChangeModules = (type, ind) => (list) => {
        const programLevels = clone(this.state.programLevels);
        if (type === 'trainings') {
            const courses = filter((e) => 1 === e.card_type_id, list);
            const tracks = filter((e) => isNil(e.card_type_id), list);
            programLevels[ind]['courses'] = courses;
            programLevels[ind]['tracks'] = tracks;
            this.setState({ programLevels });
        } else if (type === 'documents') {
            const pdf = filter((e) => 'PDF' === e.data.type, list);
            const word = filter((e) => 'Word' === e.data.type, list);
            const powerpoint = filter((e) => 'Power Point' === e.data.type, list);
            programLevels[ind]['pdf'] = pdf;
            programLevels[ind]['word'] = word;
            programLevels[ind]['powerpoint'] = powerpoint;
            this.setState({ programLevels });
        } else {
            programLevels[ind][type] = list;
            this.setState({ programLevels });
        }
    };

    handleContentPagination = (e) => {
        this.setState({ levelInd: e - 1 });
    };

    handleSave = (index, published) => () => {
        const { title, description, level, role, author_id, department_id, competency_id, category_id, programLevels, company, levelInd, iconLink } = this.state;

        //const { levelTitle, quotas } = programLevels[0];
        if (published === 1 || '') {
            if (isEmpty(title) || isEmpty(description) || isEmpty(level) || isEmpty(programLevels[0].quotas)) {
                toast.error('Please enter Title, Description and Quotas properly to publish Career.', {
                    position: toast.POSITION.TOP_RIGHT,
                    pauseOnFocusLoss: false,
                    hideProgressBar: true,
                });
                return;
            }
        } else {
            if (isNil(author_id) || isEmpty(title) || isEmpty(description)) {
                toast.error('Please enter Title and Description properly to publish a draft.', {
                    position: toast.POSITION.TOP_RIGHT,
                    pauseOnFocusLoss: false,
                    hideProgressBar: true,
                });
                return;
            }
        }

        if (index < level - 1) {
            this.handleContentPagination(levelInd + 2);
            return;
        }

        let levels = {};
        let disabled = true;
        let documents = [];
        for (let i = 0; i < level; i++) {
            const { levelTitle, habits, tracks, courses, word, pdf, powerpoint, quotas } = programLevels[i];
            const total = length(quotas) + length(habits) + length(concat(tracks, courses)) + length(concat(concat(word, pdf), powerpoint));
            const quotaDisabled = any((sl) => 0 === sl.quota_target || isNil(sl.quota_target))(programLevels[i].quotas);
            console.log({levelTitle, total, quotaDisabled, programLevels: programLevels[i] })
            disabled = isEmpty(levelTitle) || total === 0 || quotaDisabled;

            const levelQuotas = programLevels[i].quotas.map((item) => {
                return {
                    quota_template_id: item.id,
                    quota_target: item.quota_target || 0,
                    quota_calculation: item.quota_calculation || 0,
                    span_months: item.span_months || 0,
                    minimum_months: item.minimum_months || 0,
                };
            });

            let day = [],
                week = [],
                month = [];
            programLevels[i].habits.map((item) => {
                if (item.data.schedule_interval === 'day') {
                    day.push(item.id);
                } else if (item.data.schedule_interval === 'week') {
                    week.push(item.id);
                } else {
                    month.push(item.id);
                }
            });

            const trainings = concat(programLevels[i].courses, programLevels[i].tracks).map((item) => {
                const type = item.card_type_id === 1 ? 'course' : 'track';
                return {
                    type,
                    item_id: item.id,
                };
            });
            documents = concat(concat(word, pdf), powerpoint);
            levels[i + 1] = {
                title: programLevels[i].levelTitle,
                icon_url: iconLink === LibraryTypes['careers'].icon ? null : iconLink,
                quotas: levelQuotas,
                habits: { day, week, month },
                trainings: {
                    items: trainings,
                    days_to_complete: '',
                },
                chronology_lock: programLevels[i].chronology_lock,
                time_lock: programLevels[i].time_lock,
            };
        }

        if (disabled) {
            toast.error('Please enter Calculation Months and Required fields in the Quotas.', {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            return;
        }

        const program = {
            author_id,
            company_id: company.id,
            user_id: null,
            status: 0,
            designation: 1,
            title,
            level: 1,
            data: {
                levels,
                description,
                category: category_id,
                competency: competency_id,
                department: department_id,
                documents: documents,
            },
            job_role_id: role.id,
            type: 1,
            published,
        };

        const payload = {
            type: 'careers',
            data: {
                program,
            },
        };
        this.props.onSave(payload, iconLink === LibraryTypes['careers'].icon ? null : iconLink);
    };

    handleAddLevel = () => {
        let { programLevels, levelInd, level } = this.state;
        let _levels = clone(programLevels);
        _levels[levelInd + 1] = {
            levelTitle: `Level ${programLevels.length + 1}`,
            certificate_pdf: '',
            icon_url: '',
            chronology_lock: false,
            time_lock: false,
            habits: [],
            quotas: [],
            courses: [],
            tracks: [],
            pdf: [],
            word: [],
            powerpoint: [],
        };
        level = values(_levels).length;
        this.setState({ programLevels: _levels, levelInd: levelInd + 1, level });
    };
    handleLabelTitle = (title) => {
        const { programLevels, levelInd } = this.state;
        let _levels = clone(programLevels);
        _levels[levelInd].levelTitle = title;
        this.setState({ programLevels: _levels });
    };

    render() {
        const { jobs, title, description, level, levelInd, programLevels, quotaOptions, authors, departments, competencies, categories, iconLink } = this.state;

        const trainingTypes = [
            { id: 0, value: 'Attach Courses', name: 'courses' },
            { id: 1, value: 'Attach Tracks', name: 'tracks' },
        ];
        const documentTypes = [
            { id: 0, value: 'Attach Power Point', name: 'powerpoint' },
            { id: 1, value: 'Attach Word', name: 'word' },
            { id: 3, value: 'Attach PDF', name: 'pdf' },
        ];

        const expirations = [
            { id: 0, name: 'Never' },
            { id: 1, name: '6 months' },
            { id: 2, name: '12 months' },
            { id: 3, name: '24 months' },
            { id: 4, name: '36 months' },
        ];

        const settings = [
            { name: 'Author', id: null, options: authors, select: 'author' },
            { name: 'Departments', id: null, options: departments, select: 'department' },
            { name: 'Competencies', id: null, options: competencies, select: 'competency' },
            { name: 'Categories', id: null, options: categories, select: 'category' },
        ];

        const { levelTitle, chronology_lock, time_lock, habits, quotas, tracks, courses, word, pdf, powerpoint } = programLevels[levelInd];
        const trainings = concat(tracks, courses);
        const documents = concat(concat(word, pdf), powerpoint);
        const isDisabled = title === '' || description === '';

        return (
            <>
                <Filter back="all health plans" onChange={this.handleFilter} />
                <div className="lib-programs-career">
                    <div>
                        <CareerCertificationHeader
                            program={this.state}
                            type="careers"
                            changeTitle={(title) => this.setState({ title })}
                            changeDescription={(description) => this.setState({ description })}
                            editable
                        />
                    </div>

                    <div className="modules-contents mt-3">
                        <div key={`level-${levelInd}`}>
                            <div className="d-flex">
                                <p className="d-flex-1 dsl-b22 bold">Requirements</p>
                            </div>
                            <ResponsiveTabs
                                className="mb-3"
                                active={`${levelInd}`}
                                data={programLevels?.map((level, index) => ({
                                    id: `${index}`,
                                    name: level?.levelTitle?.length > 15 ? `${level.levelTitle?.substring(0, 15)}...` : level?.levelTitle || 'NA',
                                }))}
                                onTab={(e) => this.setState({ levelInd: e.id })}
                            />
                            <div className="d-flex">
                                <Input title="Level Title" value={programLevels[levelInd].levelTitle} onChange={this.handleLabelTitle} />
                            </div>

                            <div className="required-field pt-4">
                                <p className="dsl-b18 text-500">Goals</p>
                                <ProgramsList.QuotaList modules={quotas} quotaOptions={quotaOptions} onChange={this.handleChangeModules('quotas', levelInd)} type="career" />
                                <div className="d-h-end pt-4">
                                    <Button name="Attach Goal" type="low" onClick={this.handleAddModule('quotas', levelInd)} />
                                </div>
                            </div>
                            <div className="required-field">
                                <TrainingCourses data={trainings} isEditable onChange={this.handleChangeModules('trainings', levelInd)} />
                                <div className="d-h-end py-4">
                                    <Dropdown
                                        align="right"
                                        width="fit-content"
                                        caret="none"
                                        returnBy="data"
                                        placeholder="Attach Learning"
                                        className="add-training-dropdown"
                                        selectable={false}
                                        data={trainingTypes}
                                        onChange={this.handleSelectModule(levelInd)}
                                    />
                                </div>
                            </div>
                            <div className="py-4">
                                <p className="dsl-b18 text-500">Expiration</p>
                                <Dropdown className="expiration-dropdown" align="right" title="Expires:" data={expirations} getValue={(e) => e.name} />
                            </div>
                        </div>
                    </div>
                    <div className="mt-3 d-h-end">
                        <Button name="Add Level" type="low" onClick={this.handleAddLevel} />
                    </div>
                    <Settings values={settings} isEditable expanded handleSelect={this.handleSelectTags} />
                    <div className="d-flex flex-column pt-3">
                        <div className="d-h-end mt-2">
                            <>
                                <Button className="btn-save me-3" name="Draft" disabled={isDisabled} type="low" onClick={this.handleSave(levelInd, 0)} />
                                <Button className="btn-save" name="Publish" disabled={isDisabled} onClick={this.handleSave(levelInd, 1)} />
                            </>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

Add.propTypes = {
    tags: PropTypes.shape({
        authors: PropTypes.array,
        departments: PropTypes.array,
        competencies: PropTypes.array,
        categories: PropTypes.array,
    }),
    company: PropTypes.shape({
        id: PropTypes.number,
    }),
    jobs: PropTypes.array,
    quotaOptions: PropTypes.array,
    onSave: PropTypes.func,
    onModal: PropTypes.func,
};

Add.defaultProps = {
    tags: {
        authors: [],
        departments: [],
        competencies: [],
        categories: [],
    },
    company: {
        id: 0,
    },
    jobs: [],
    quotaOptions: [],
    onSave: () => {},
    onModal: () => {},
};

export default Add;
